import React from 'react'
import { FreeTextCard } from '../tracks/FreeTextCard.jsx'
import { CommitmentListCard } from './CommitmentListCard.jsx'
import { SectionNote } from '../annotations/SectionNote.jsx'

/**
 * Zone 3: Forward look section.
 * Two cards (focus areas + commitments) with inline manager notes, plus section note.
 */
export function ForwardLookSection({
  data = {},
  onChange,
  managerNotes = {},
  onManagerNoteChange,
  onPromoteToTask,
  createSuggestHandler,
  isEmployee,
  isManager,
  isShared,
  isReady,
  isClosed,
  employeeName,
  me,
  reports,
}) {
  const readOnly = isClosed || !isEmployee

  function handleCard1Change(value) {
    onChange?.({ ...data, card1: { ...data.card1, text: value } })
  }

  function handleCommitmentsChange(items) {
    onChange?.({ ...data, card2: { ...data.card2, items } })
  }

  return (
    <div style={styles.section}>
      <h3 style={styles.title}>Forward look</h3>

      <FreeTextCard
        tag="FOCUS"
        title="Focus areas"
        value={data.card1?.text || ''}
        onChange={handleCard1Change}
        placeholder="Where do you want to put your energy next period?"
        readOnly={readOnly}
        isClosed={isClosed}
        managerNote={managerNotes.card1 || ''}
        onManagerNoteChange={(v) => onManagerNoteChange?.({ ...managerNotes, card1: v })}
        onSuggestManagerNote={createSuggestHandler?.('forwardLook', 'card1')}
        isManager={isManager}
        isReady={isReady}
        isShared={isShared}
      />

      <CommitmentListCard
        items={data.card2?.items || []}
        onChange={handleCommitmentsChange}
        onPromoteToTask={onPromoteToTask}
        readOnly={readOnly}
        isClosed={isClosed}
        me={me}
        reports={reports}
        managerNote={managerNotes.card2 || ''}
        onManagerNoteChange={(v) => onManagerNoteChange?.({ ...managerNotes, card2: v })}
        onSuggestManagerNote={createSuggestHandler?.('forwardLook', 'card2')}
        isManager={isManager}
        isReady={isReady}
        isShared={isShared}
      />

      <SectionNote
        value={managerNotes.section || ''}
        onChange={(v) => onManagerNoteChange?.({ ...managerNotes, section: v })}
        onSuggest={createSuggestHandler?.('forwardLook', 'section')}
        isManager={isManager}
        isShared={isShared}
        isReady={isReady}
        isClosed={isClosed}
        employeeName={employeeName}
      />
    </div>
  )
}

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  title: {
    fontSize: '15px',
    fontWeight: 700,
    color: 'var(--text-primary)',
    margin: 0,
  },
}
